export const protectedRouteActionText = 'Switch accounts';

export const protectedRouteWarnMessage =
  'You most likely clicked on a link to a transaction that is associated to another account.';

export const protectedRouteReturnText = 'No thanks, go back to my dashboard';

export const protectedRouteWarnTitle = 'You don’t have permission to view this transaction.';
